import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQ() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      q: t('landing.faq.q1q', { defaultValue: 'Do I need a credit card to start?' }),
      a: t('landing.faq.q1a', { defaultValue: "No. The Free plan gives you 5 generations per day with zero payment info. Just sign up and start creating." }),
    },
    {
      q: t('landing.faq.q2q', { defaultValue: 'How fast can I get my first result?' }),
      a: t('landing.faq.q2a', { defaultValue: "Under 30 seconds. Describe your niche, pick a tone, click generate — your bio, caption, or hashtag set is ready to copy-paste." }),
    },
    {
      q: t('landing.faq.q3q', { defaultValue: 'What languages are supported?' }),
      a: t('landing.faq.q3a', { defaultValue: "Free supports English and Portuguese. Plus unlocks all current languages including Spanish, French, and German. Pro gets priority access to every new language we add." }),
    },
    {
      q: t('landing.faq.q4q', { defaultValue: "What's the difference between Plus and Pro?" }),
      a: t('landing.faq.q4a', { defaultValue: "Plus is the complete toolkit for individual creators — 250 generations/month, all languages, refine, saved library, and brand profiles. Pro is built for professionals and agencies managing multiple accounts at scale, with 750 generations/month and priority support." }),
    },
    {
      q: t('landing.faq.q5q', { defaultValue: 'Is the generated content unique?' }),
      a: t('landing.faq.q5a', { defaultValue: "Yes. Every generation is tailored to your specific niche, tone, and inputs. No templates, no recycled text — each output is original." }),
    },
    {
      q: t('landing.faq.q6q', { defaultValue: 'Can I cancel anytime?' }),
      a: t('landing.faq.q6a', { defaultValue: "Absolutely. No contracts, no lock-in. Cancel with one click from your billing page. You keep access until the end of your billing period." }),
    },
  ];

  return (
    <section id="faq">
      <div className="section-label">{t('landing.faq.label', { defaultValue: 'FAQ' })}</div>
      <h2 className="section-title">{t('landing.faq.title1', { defaultValue: 'Common ' })}<em>{t('landing.faq.title2', { defaultValue: 'questions' })}</em></h2>
      <div className="faq-list">
        {faqs.map((faq, i) => (
          <div key={i} className={`faq-item ${openIndex === i ? 'open' : ''}`}>
            <div className="faq-q" onClick={() => setOpenIndex(openIndex === i ? null : i)}>
              {faq.q}
              <span className="arrow" style={{ transform: openIndex === i ? 'rotate(45deg)' : 'none' }}>+</span>
            </div>
            {openIndex === i && <div className="faq-a">{faq.a}</div>}
          </div>
        ))}
      </div>
    </section>
  );
}
